export const state = {
    response: null,
};

export default state;
